import { Component, EventEmitter, inject, Input, OnChanges, Output, signal, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DamageReport } from '../../../models/damage-report';
import { CustomerService } from '../../../services/customers/customer-service';
import { Customer } from '../../../models/customer';
import { CarService } from '../../../services/vehicles/car-service';
import { Car } from '../../../models/car';

@Component({
  selector: 'app-damage-report-details',
  imports: [CommonModule],
  templateUrl: './damage-report-details.html',
  styleUrl: './damage-report-details.scss'
})
export class DamageReportDetails implements OnChanges {
  @Input() report: DamageReport;
  @Input() currentIndex = 0;
  @Input() total = 0;
  @Input() activeTab: string | null = 'PENDING';

  @Output() acknowledge = new EventEmitter<void>();
  @Output() reject = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() tabChange = new EventEmitter<string>();

  private customerService = inject(CustomerService);
  private carService = inject(CarService);

  customerDetails = signal<Customer | null>(null);
  carDetails = signal<Car | null>(null);

  lightboxOpen = false;
  lightboxIndex = 0;

  get isPending(): boolean { return this.report?.status === 'PENDING'; }
  get hasPrev(): boolean { return this.currentIndex > 0; }
  get hasNext(): boolean { return this.currentIndex < this.total - 1; }

  get photos(): string[] { return this.report?.images ?? []; }

  get customerInitials(): string {
    const f = (this.report?.customerFirstName ?? '').trim()[0] ?? '';
    const l = (this.report?.customerLastName ?? '').trim()[0] ?? '';
    return (f + l).toUpperCase() || '?';
  }

  get statusClass(): string {
    switch (this.report?.status) {
      case 'ACKNOWLEDGED': return 'status--acknowledged';
      case 'REJECTED': return 'status--rejected';
      default: return 'status--pending';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['report'] && this.report) {
      if (this.report.customerEmail) {
        this.customerDetails.set(null);
        this.customerService.getCustomersList({ search: this.report.customerEmail, size: 1 })
          .subscribe({ next: (res) => this.customerDetails.set(res.data.content?.[0] ?? null) });
      }
      if (this.report.plateNo) {
        this.carDetails.set(null);
        this.carService.getCarsList({ search: this.report.plateNo, size: 1 })
          .subscribe({ next: (res) => this.carDetails.set(res.data.content?.[0] ?? null) });
      }
    }
  }

  openLightbox(index: number): void {
    this.lightboxIndex = index;
    this.lightboxOpen = true;
  }

  lightboxPrev(): void { if (this.lightboxIndex > 0) this.lightboxIndex--; }
  lightboxNext(): void { if (this.lightboxIndex < this.photos.length - 1) this.lightboxIndex++; }

  onTabChange(tab: string) { this.tabChange.emit(tab); }
  onPrev() { this.prev.emit(); }
  onNext() { this.next.emit(); }
  onAcknowledge() { this.acknowledge.emit(); }
  onReject() { this.reject.emit(); }
}
